export default async (ctx, inject) => {
  /* const { SEARCH_PAGES, SEARCH_OTHER_PAGES } = await import('~/utils/search/search.constants')

  if ([...SEARCH_PAGES, ...SEARCH_OTHER_PAGES].includes(ctx.route.name)) { */
  let searchInstance

  if (process.client) {
    if (window.Search) {
      searchInstance = window.Search
    } else {
      const { Search } = await import('~/utils/search/search.class')
      searchInstance = window.Search = new Search(ctx)
    }
  } else {
    const { Search } = await import('~/utils/search/search.class')
    searchInstance = new Search(ctx)
  }

  ctx.store.dispatch('data/getBoatFormData', { type: null, data: { only: ['getCharterTypes'] } })
  inject('Search', searchInstance)
  // }
}
